import type { InlineRenderCtx } from '../inline-markup-types';

// `serializeEditableText` recovers a token from `data-inline-raw` alone, so a kind that omits it serializes
// down to the chip's visible label and silently loses the markup.
export const inlineChipProps = (ctx: InlineRenderCtx) => {
  return { 'data-inline-raw': ctx.raw, contentEditable: ctx.editable ? false : undefined };
};
